/**
   gatsby-browser.js
    cfr. https://www.gatsbyjs.com/docs/browser-apis/
    see tests & trials commented in/_backup/gatsby-browser_sw-listeners.js
 */

// ES6 import not compatible with JS export.x = require('')
// require('./src/styles/style.css')
import './src/styles/style.css'
import './src/styles/wizard.css'

// Both gatsby-browser.js and gatsby-ssr.js have access to this hook and it’s recommended to wrap both with our provider
//      solution from https://www.digitalocean.com/community/tutorials/gatsbyjs-state-management-in-gatsby
import ContextProvider from './src/components/ContextProvider'

// exports.onInitialClientRender = require('./src/gatsby/browser/onInitialClientRender') // onInitialClientRender DEPRECATED
export const wrapRootElement = ContextProvider

// PWA is SPA en herlaad pages niet bij wijziging rout, stuur gtag event bij user navigation action
export const onRouteUpdate = ({ location }) => {
    if (typeof window.gtag === 'function') {
        // wacht heel even tot document.title en location volledig geüpdatet zijn
        setTimeout(() => {
            window.gtag('config', 'G-364T6GSNXW', {
                page_path: location.pathname + location.search + location.hash,
                page_title: document.title,
                page_location: window.location.href,
            });
        }, 0);
    }
}